import React from "react";
export var DriveContext = React.createContext([]);
export var DriveContextProvider = DriveContext.Provider;
export var DriveContextConsumer = DriveContext.Consumer;
//# sourceMappingURL=drive.js.map